import styled from 'styled-components';
import { colors, s8 } from '@ardoq/design-tokens';
import { HEADER_BAR_HEIGHT } from '../../consts';

export const WidgetHeaderBar = styled.div`
  display: flex;
  width: 100%;
  height: ${HEADER_BAR_HEIGHT}px;
  border-bottom: 1px solid ${colors.borderSubtle};
  align-items: center;
  padding: ${s8} 0;
`;
